// Model.js
// -----------------------
// @module Case
define("Ames.OperationGuidesPage.OperationGuidesPage.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/OperationGuidesPage/SuiteScript2/OperationGuidesPage.Service.ss"
            ),
            true
        )
});
});
